import { typeService } from '../../services'

// initial state
const state = () => ({
  types: [],
  type: null
})

// actions
const actions = {
  getTypes({ commit }) {
    typeService.getTypes().then(
      (types) => {
        const fixedOrder = ['Space', 'Stuff', 'Staff', 'Service']
        const ordered = []
        fixedOrder.forEach((typeName) => {
          const type = types.find((type) => type.name === typeName)
          if (type) {
            ordered.push(type)
          }
        })
        commit('getTypesSuccess', ordered)
      },
      (error) => {
        commit('getTypesFailure', error)
      }
    )
  },
  getType({ commit }, typeId) {
    typeService.getType(typeId).then(
      (type) => {
        commit('getTypeSuccess', type)
      },
      (error) => {
        commit('getTypeFailure', error)
      }
    )
  },
  createType({ commit }, typeData) {
    typeService.createType(typeData).then(
      (type) => {
        commit('getTypeSuccess', type)
      },
      (error) => {
        commit('getTypeFailure', error)
      }
    )
  },
  updateType({ commit }, { typeId, typeData }) {
    typeService.updateType(typeId, typeData).then(
      (type) => {
        commit('getTypeSuccess', type)
      },
      (error) => {
        commit('getTypeFailure', error)
      }
    )
  },
  deleteType({ commit }, typeId) {
    typeService.deleteType(typeId).then(
      (type) => {
        commit('getTypeSuccess', type)
      },
      (error) => {
        commit('getTypeFailure', error)
      }
    )
  }
}

// mutations
const mutations = {
  getTypesSuccess(state, types) {
    state.types = types
  },
  getTypeSuccess(state, type) {
    state.type = type
  },
  getTypesFailure(state, error) {
    console.log(state, error)
  },
  getTypeFailure(state, error) {
    console.log(state, error)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
